import { CircularProgress, Grid } from "@mui/material";
import { Box } from "@mui/system";
import { Formik } from "formik";
import React, { useState } from "react";
import { useStyles } from "../../assets/styles/BloodSugarStyles";
import { StyledButton, StyledCrossIcon, StyledFormik } from "../../assets/styles/CommonStyles";
import strings from "../../constant/strings";
import { heartRateSchema } from "../../utils/forms/schema.heartRateSchema";
import FieldWrapper from "../InputField/TextFieldWrapper";
import * as mainService from "../../services/mainService.js";
import { toast } from "react-toastify";
import { pulseLocation } from "../../constant/staticLists";
import { capitalizeFirstLetter } from "../../constant/staticHelper";
import BloodSugarLevelDropdown from "../control/BloodSugarLevelDropdown";
import { useSelector } from "react-redux";
import SelectionDropdown from "../control/SelectionDropdown";

const HeartRate = ({ setOpenModal, getUpdatedValue }) => {
  const classes = useStyles();
  let initialValues= {
    pulse: "",
    location: "",
    note: ""
  }
  const bodyTempLists = Object.keys(pulseLocation).map(key => ({
    label: capitalizeFirstLetter(key.replace(/_/g, ' ').toLowerCase()),
    level: pulseLocation[key]
  }));
  const [buttonLoading, setButtonLoading] = useState(false);

  const { userData } = useSelector((state) => ({
    userData: state.auth.userData
  }));


  const handleSubmit = async (values, {resetForm}) => {
    const data = {
      pulse: values.pulse,
      location: values.location,
      notes: values.note,
      token: userData.token
    }
    const res = await mainService.addHeartRateApi(data);

    if (res.response_type === "fail") {
      setButtonLoading(false);
      toast.error(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: {width: 'auto', borderRadius: 8 }});
    } else {
      resetForm();
      setButtonLoading(false);
      getUpdatedValue(true);
      setOpenModal(false);
      toast.success(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: {width: 'auto', borderRadius: 8 }});
    }
  }

  return (
    <div>
      <Grid className={classes.secondayCont}>
        <h2 className={classes.mainCont}>{strings.heartRate}</h2>
        <StyledCrossIcon
          src={"/assets/img/x.png"}
          alt="User"
          onClick={() => setOpenModal(false)}
        />

      </Grid>
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={heartRateSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            errors,
            values,
            handleSubmit, setFieldValue, validateField
          }) => {
            const handleDropdownValue = (data) => {
              if (data) {
                const ids = data.level;
                setFieldValue("location", ids);
              } else {
                setFieldValue("location", '');
              }
              validateField("location");
            };
          return(
            <StyledFormik>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FieldWrapper
                    name="pulse"
                    label={`${strings.pulsePerMin}`}
                    type="number"
                    onChange={(e) => {
                      handleChange("pulse")(e);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                <SelectionDropdown
                    name="location"
                    label={`${strings.bodyPart}`}
                    list={bodyTempLists}
                    handleDropdownValue={handleDropdownValue}
                  />
                  {/* <BloodSugarLevelDropdown
                    name="location"
                    label={`${strings.bodyPart}`}
                    onChange={(e) => {
                      handleChange("location")(e);
                    }}
                    list={bodyTempLists}
                  /> */}
                </Grid>
                <Grid item xs={12}>
                  <FieldWrapper
                    name="note"
                    type="text"
                    label={`${strings.note}`}
                    onChange={(e) => {
                      handleChange("note")(e);
                    }}
                  />
                </Grid>
              </Grid>
              <Box m={1} pt={1}>
                <StyledButton
                  name="submit"
                  disabled={Object.keys(errors).length > 0 || buttonLoading}
                  onClick={handleSubmit}
                  variant="contained">
                  {buttonLoading ? (
                    <CircularProgress
                      style={{ color: "white" }}
                      size={20}
                      thickness={5}
                    />
                  ) : `${strings.save}`}

                </StyledButton>
              </Box>
            </StyledFormik>
          )}}
        </Formik>
      </div>
    </div>
  )
}

export default HeartRate;